import { render, staticRenderFns } from "./AssetFull.vue?vue&type=template&id=d45c4fbe"
import script from "./AssetFull.vue?vue&type=script&lang=js"
export * from "./AssetFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports